import styled from 'styled-components';
import Colours from '/shared/styled/Colours';

export default styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;

  > a {
    color: ${Colours.blackDark1};
    background-color: ${Colours.white};
    min-width: 220px;
    max-width: 256px;

    &:hover {
      opacity: 1;
    }
  }
`;
